exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selectedElementDiv[data-v-49da9970] {\n  min-height: 80px;\n  padding-top: 10px;\n  background-color: lightgray;\n  border: 2px dotted black;\n}\n.selectedElementDiv h4[data-v-49da9970] {\n  line-height: 80px;\n  color: white;\n  text-align: center;\n}\n", ""]);

// exports
